module.exports = {
	catagory: "personal preference",
	defaultImage: "https://images.unsplash.com/photo-1561911957-98085a69688e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1632&q=80",
	questions: [
		{
			questionText: `I like:`,
			optional: false,
			questionDifficulty: 0,
			answerOptions: {
				correct: [
					"Chinese Green",
					"Japanese Green",
					"Chinese Red",
					"Indian Black",
					"African Black",
					"1st Flush Darjeeling",
					"Late Flush Darjeeling",
					"Fermented",
					"Flavored",
					"Herbal",
				]
			},
			response: [`You like `, `Tea.`],
			tags: [""],
			citations: ``,
			image: ``
		},
		{
			questionText: `I like:`,
			optional: false,
			questionDifficulty: 0,
			answerOptions: {
				correct: [
					`Sweet`,
					`Sour`,
					`Bitter`,
					`Astringent`,
					`Umami`,
				]
			},
			response: [`You like `, `flavors.`],
			tags: [""],
			citations: ``,
			image: ``
		},
		{
			questionText: `I prepare tea with a:`,
			optional: false,
			questionDifficulty: 0,
			answerOptions: {
				correct: [
					`Teabag`,
					`Brewing Basket`,
					`Ceramic Tea Pot`,
					`Metal Tea Pot`,
					`Glass Tea Pot`,
					`Gaiwan`,
					`ISO cups/bowls`,
				]
			},
			response: [`You use a `, `to prepare tea.`],
			tags: [""],
			citations: ``,
			image: ``
		},
		{
			questionText: `I drink tea with:`,
			optional: false,
			questionDifficulty: 0,
			answerOptions: {
				correct: [
					`Creamer`,
					`Sugar`,
					`Ice`,
				]
			},
			response: [`You like `, `in your tea.`],
			tags: [""],
			citations: ``,
			image: ``
		},
		{
			questionText: `My monthly tea budget is:`,
			optional: true,
			questionDifficulty: 0,
			answerOptions: {
				correct: [
					`Nothing`,
					`$5-$10`,
					`$10-$25`,
					`$25-$50`,
					`$50-$100`,
					`+$100`,
				]
			},
			response: [``, ``],
			tags: [""],
			citations: ``,
			image: ``
		},
	]
}

// 
// 		{
// 			questionText: ``,
//			optional: false,
// 			questionDifficulty: 0,
// 			answerOptions: {
// 				correct: [
// 					``,
// 				]
// 			},
//			response: [``, ``],
// 			tags: [""],
// 			citations: ``,
// 			image: ``
// 		},